<template>
  <div class="salary-approvel">
    <div class="salary-approvel-container">
      <div class="left-container">
        <div class="add-type-content">
          <div v-if="procedureList.length > 0">
            <div
              :class="activeIndex === index ? 'type active' : 'type'"
              v-for="(item, index) in procedureList"
              :key="index"
              @click="selectType(index, item)"
            >
              <div class="type-title">
                <img src="../../../../assets/tree/random.png" />
                <div>{{ item.name }}</div>
              </div>
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  <img src="../../../../assets/tree/three-spot.png" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="beforeHandleCommand(item, 'delete', index)"
                    class="delete"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="nothing-add" v-if="procedureList.length == 0">
            <div>
              <div>
                <img src="../../../../assets/nothing-add.png" />
              </div>
              <p>请先增分类</p>
            </div>
          </div>
        </div>
        <el-button
          v-if="
            OPERATION_LIST.findIndex(
              (item) => item === OPERATIONS_BTNS.roleAddSalaryApproveSetting
            ) !== -1
          "
          type="text"
          class="btn-border-text-blue add-type"
          @click="addProcedure"
          >新增流程</el-button
        >
      </div>
      <div class="right-container">
        <div v-if="procedureList.length > 0">
          <div class="sub-title">发起审批</div>
          <div class="row">
            <div class="step">
              <div class="step-num">0</div>
              <div class="step-main">
                <div class="step-main-left">经办人：{{ agent }}</div>
                <div class="step-main-right" @click="setUp">设置</div>
              </div>
            </div>
          </div>
          <div v-for="(item, index) in detailsList" :key="index">
            <div class="sub-title">{{ approvelObj[item.approveType] }}</div>
            <div class="row">
              <div class="step">
                <div :class="item.isContinue ? 'step-active' : 'step-num'">
                  {{ index + 1 }}
                </div>
                <div class="step-main">
                  <div class="step-main-left">
                    {{ item.roleName }}：{{ item.userName }}
                  </div>
                  <div class="operation-btn">
                    <div
                      v-if="item.roleType == 1 && item.isAddDeptApproval"
                      class="step-main-right"
                      @click="addDeptApproval(index)"
                    >
                      新增
                    </div>
                    <div
                      v-if="item.roleType == 1"
                      class="step-main-right"
                      @click="setDeptApproval(index)"
                    >
                      设置
                    </div>
                    <div
                      v-if="item.roleType == 13"
                      class="step-main-right"
                      @click="setOtherApproval(index)"
                    >
                      设置
                    </div>
                    <div
                      v-if="item.isDelDeptApproval"
                      class="step-main-right del"
                      @click="delDeptApproval(index)"
                    >
                      删除
                    </div>
                    <div
                      v-if="!item.isContinue && item.isDeptApprovalNeedContinue"
                      class="step-main-right"
                      @click="skip(index)"
                    >
                      跳过
                    </div>
                    <div
                      v-if="item.isContinue"
                      class="step-main-right"
                      @click="recovery(index)"
                    >
                      恢复
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="financial-audit"
                v-if="item.roleType == 3 || item.roleType == 2"
              >
                <span class="financial-title">审批人</span>
                <el-radio-group
                  v-model="item.userRadio"
                  @change="changeRadio(item.userRadio, index)"
                >
                  <el-radio
                    :label="v.userId"
                    :disabled="item.isContinue == 1"
                    v-for="(v, index) in item.userNameList"
                    :key="index"
                    >{{ v.userName }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
        <div
          class="foot-container"
          v-if="
            OPERATION_LIST.findIndex(
              (item) => item === OPERATIONS_BTNS.roleSaveSalaryApproveSetting
            ) !== -1
          "
        >
          <el-button class="btn-blue" type="primary" @click="save"
            >保存</el-button
          >
        </div>
        <div class="nothing" v-if="procedureList.length == 0">
          <div>
            <div>
              <img src="../../../../assets/nothing.png" />
            </div>
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择模板 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="工薪模板" prop="salaryTmpId">
          <el-select
            v-model="form.salaryTmpId"
            placeholder="请选择模板"
            class="gray white"
            clearable
          >
            <el-option
              v-for="item in salaryTmpList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>

    
    <!-- 选择部门负责人 -->
    <el-dialog
      class="select-dept-approval"
      title="选择部门负责人"
      :visible.sync="dialogDeptApprovalVisible"
      width="540px"
      :before-close="handleDeptApprovalClose"
    >
      <div class="dialog-content">
        <div
          :class="
            departmentActiveIndex === index
              ? 'departmentActive department-people'
              : 'department-people'
          "
          v-for="(item, index) in departmentPeopleList"
          :key="index"
          @click="selectDepartmentPeople(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDeptApprovalClose">取 消</el-button>
        <el-button type="primary" @click="handleDeptApprovalClose">确 定</el-button>
      </span>
    </el-dialog>

    
    <!-- 选择其他审批人 -->
    <el-dialog
      title="设置"
      :visible.sync="setOtherApprovalDialogVisible"
      width="540px"
      :before-close="setOtherApprovaClose"
    >
      <div class="set-other-approval">
        <div class="table-right">
          <p class="title">每次最多可添加1个成员</p>
          <tree-people
            :companyList="companyList"
            :departmentId="departmentId"
            @selectTreeNodeList="selectDepartmentList"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setOtherApprovaClose"
          >取 消</el-button
        >
        <el-button type="primary" @click="setOtherApprovaConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Salary from "@/models/salary.js";
import Staff from "@/models/staff.js";
import TreePeople from "@/components/tree-people.vue";
import { config } from "@/common/js/config.js";
import { getTeamId } from "common/js/storage";
import { mapChild } from "@/common/js/utils.js";
import { operationMixins } from "@/common/mixins/operation/operation.js";
export default {
  mixins: [operationMixins],
  components: {
    TreePeople,
  },

  data() {
    return {
      activeIndex: 0,
      /* 流程集合 */
      procedureList: [],
      agent: "",
      agentId: [],
      detailsList: [],
      approvelObj: {
        0: "财务审批",
        1: "领导审批",
        2: "部门审批",
        3: "其他审批",
      },
      staffAndDepartmentList: [],

      salaryTmpList: [],
      dialogTitle: "选择工薪模板",
      dialogVisible: false,
      form: {
        salaryTmpId: "",
      },
      rules: {
        salaryTmpId: [
          { required: true, message: "请选择工薪模板", trigger: "change" },
        ],
      },


      dialogDeptApprovalVisible: false,
      departmentPeopleList: [],
      departmentActiveIndex: null,
      detailsActiveIndex: 0,

      // 设置其他审批人弹框开关
      setOtherApprovalDialogVisible: false,
      // 其他审批人部门成员列表
      companyList: [],
      departmentId: 0,
      // 其他审批人位置索引
      detailsSetOtherActiveIndex: 0,
      // 选中的其他审批人信息
      otherInfo: null
    };
  },

  created() {
    config();
    this.initTmpList();
    this.initDetails();
    this.initDepartmentList()
  },

  methods: {
    /* 获取部门数据 */
    initDepartmentList() {
      let searchDepartment = "";
      let id = getTeamId()
      Staff.getDepartmentPeopleList(id, searchDepartment).then((res) => {
        if (res.success) {
          this.companyList = mapChild(res.result);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 某角色的管理范围内的组织信息 */
    initRoleType(roleType, isAdd) {
      let templateId = this.agentId[0];
      Salary.getRoleType(templateId, roleType).then((res) => {
        if (res.success) {
          if (res.result.length > 0) {
            if (roleType == 1) {
              let arr = []
              res.result.map(i => {
                let obj = {}
                obj.userId = i.userId
                obj.name = i.userName
                arr.push(obj)
              })
              this.departmentPeopleList = arr
            }
            if (roleType == 3) {
              this.$set(this.detailsList[this.detailsList.length - 5], 'userNameList', res.result)
              if (isAdd) {
                this.detailsList[this.detailsList.length - 5].userRadio = res.result[0].userId;
                this.detailsList[this.detailsList.length - 5].userName = res.result[0].userName;
              }
            }
            if (roleType == 4)
              this.detailsList[this.detailsList.length - 4].userName = res.result[0].userName;
            if (roleType == 2) {
              this.$set(this.detailsList[this.detailsList.length - 3], 'userNameList', res.result)
              if (isAdd) {
                this.detailsList[this.detailsList.length - 3].userName = res.result[0].userName;
                this.detailsList[this.detailsList.length - 3].userRadio = res.result[0].userId;
              }
            }
            if (roleType == 6) {
              let centralLeader = []
              res.result.map(i => {
                centralLeader.push(i.userName)
              });
              this.detailsList[this.detailsList.length - 2].userName = centralLeader.join('；')
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 获取部门负责人角色用户 */
    initDeptApproval(isAdd) {
      this.initRoleType(1, isAdd);
    },

    /* 获取财务审核人角色用户 */
    initFinancialReviewer(isAdd) {
      this.initRoleType(3, isAdd);
    },

    /* 获取财务负责人角色用户 */
    initFinancialDirector(isAdd) {
      this.initRoleType(4, isAdd);
    },

    /* 获取财务分管领导角色用户 */
    initDeputyLeader(isAdd) {
      this.initRoleType(2, isAdd);
    },

    /* 获取单位主官角色用户 */
    initHierarchicalSuperior(isAdd) {
      this.initRoleType(6, isAdd);
    },

    initEveryRoleTypeList(isAdd) {
      this.initDeptApproval(isAdd)
      this.initFinancialReviewer(isAdd);
      this.initFinancialDirector(isAdd);
      this.initDeputyLeader(isAdd);
      this.initHierarchicalSuperior(isAdd);
    },

    /* 获取模板列表 */
    initTmpList() {
      Salary.getSalaryTmpList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            arr.push(obj);
          });
          this.salaryTmpList = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    initDetails() {
      Salary.getApprovalList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i, index) => {
            let nums = 0
            let obj = {};
            obj.id = i.id;
            obj.agentId = [];
            obj.agent = [];
            obj.name = `流程${index + 1}`;
            i.approveSettingSalaryTempalteRelateVoList.map((v) => {
              obj.agentId.push(v.templateId);
              obj.agent.push(v.name);
            });
            obj.agentDepartmentList = [];
            i.approveSettingDetailVoList.map((v, index) => {
              let obj2 = {};
              obj2.isContinue = v.isContinue;
              obj2.roleType = v.roleType;
              obj2.roleId = v.roleId;
              obj2.roleName = v.roleName;
              obj2.userId = v.userId;
              obj2.userRadio = v.userId;
              obj2.userName = v.userName;
              obj2.approveSettingId = v.approveSettingId;
              obj2.isAddDeptApproval = 0;
              obj2.isDeptApprovalNeedContinue = 1
              if (v.roleType == 1) {
                if (index == 1 || index == 2) {
                  obj2.isDelDeptApproval = 1
                  obj2.isDeptApprovalNeedContinue = 0
                }
                nums++
                if (index === 0) obj2.approveType = 2
              }
              if (v.roleType == 2) obj2.approveType = 1
              if (v.roleType == 3) obj2.approveType = 0
              obj.agentDepartmentList.push(obj2);
            });
            if(nums < 3) {
              obj.agentDepartmentList[0].isAddDeptApproval = 1
            }
            arr.push(obj);
          });
          this.procedureList = arr;
          this.detailsList = arr.length > 0 ? arr[0].agentDepartmentList : [];
          let otherInfo = null
          if (this.detailsList.length) {
            if (this.detailsList[this.detailsList.length - 1].userRadio) {
              otherInfo = {}
              otherInfo.userId = this.detailsList[this.detailsList.length - 1].userRadio
              otherInfo.name = this.detailsList[this.detailsList.length - 1].userName
            }
          }
          this.otherInfo = otherInfo
          this.agentId = arr.length > 0 ? arr[0].agentId : [];
          this.agent = arr.length > 0 ? arr[0].agent.join(";") : "";
          if (this.agentId.length > 0) {
            this.initEveryRoleTypeList(false)
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    
    selectType(index, item) {
      this.activeIndex = index;
      this.detailsList = item.agentDepartmentList;
      let otherInfo = null
      if (this.detailsList.length) {
        if (this.detailsList[this.detailsList.length - 1].userRadio) {
          otherInfo = {}
          otherInfo.userId = this.detailsList[this.detailsList.length - 1].userRadio
          otherInfo.name = this.detailsList[this.detailsList.length - 1].userName
        }
      }
      this.otherInfo = otherInfo
      this.agentId = item.agentId;
      this.agent = item.agent.join("；");
      if (this.agentId.length>0) this.initEveryRoleTypeList(false)
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command, index) {
      return {
        value: value,
        command: command,
        index: index,
      };
    },

    handleCommand(command) {
      switch (command.command) {
        case "delete":
          this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
            confirmButtonText: "删除",
            cancelButtonText: "取消",
            confirmButtonClass: "btn-red",
            cancelButtonClass: "btn-gray",
          }).then(() => {
            if (command.value.id) {
              this.delProcedureList(command.value.id);
            } else {
              this.procedureList.splice(command.index, 1);
            }
          });
          break;
      }
    },

    /* 删除流程 */
    delProcedureList(id) {
      let data = {
        id,
      };
      Salary.postDelApproval(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "流程删除成功",
          });
          this.activeIndex = 0;
          this.initDetails();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 新增流程 */
    addProcedure() {
      let length = this.procedureList.length;
      let obj = {
        agentId: [],
        agent: [],
        name: `流程${length + 1}`,
        agentDepartmentList: [
          {
            roleType: 1,
            roleName: "部门负责人",
            isContinue: 0,
            isAddDeptApproval: 1,
            isDelDeptApproval: 0,
            isDeptApprovalNeedContinue: 1,
            approveType: 2,
            userRadio: "",
            userName: "",
            userNameList: [],
          },
          {
            roleType: 3,
            roleName: "财务审核人",
            isContinue: 0,
            isAddDeptApproval: 0,
            isDeptApprovalNeedContinue: 1,
            approveType: 0,
            userRadio: "",
            userName: "",
            userNameList: [],
          },
          {
            roleType: 4,
            roleName: "财务负责人",
            isContinue: 0,
            isAddDeptApproval: 0,
            isDeptApprovalNeedContinue: 1,
            userRadio: 0,
            userName: "",
          },
          {
            roleType: 2,
            roleName: "业务分管领导",
            isContinue: 0,
            isAddDeptApproval: 0,
            isDeptApprovalNeedContinue: 1,
            userRadio: 0,
            userName: "",
            approveType: 1,
          },
          {
            roleType: 6,
            roleName: "单位主官",
            isContinue: 0,
            isAddDeptApproval: 0,
            isDeptApprovalNeedContinue: 1,
            userRadio: "",
            userName: "",
            userNameList: [],
          },
          {
            roleType: 13,
            roleName: "其他审批人",
            approveType: 3,
            isContinue: 0,
            isAddDeptApproval: 0,
            isDeptApprovalNeedContinue: 1,
            userRadio: "",
            userName: "",
            userNameList: [],
          },
        ],
      };
      this.departmentPeopleList = []
      this.procedureList.push(obj);
      this.detailsList =
        this.procedureList[this.activeIndex].agentDepartmentList;
    },

    handleDeptApprovalClose() {
      this.dialogDeptApprovalVisible = false
    },

    selectDepartmentPeople(row, index) {
      this.departmentActiveIndex = index
      this.detailsList[this.detailsActiveIndex].userName = row.name
      this.detailsList[this.detailsActiveIndex].userRadio = row.userId
    },

    setDeptApproval(index) {
      this.detailsActiveIndex = index
      this.dialogDeptApprovalVisible = true
    },

    /* 设置其他审批人 */
    setOtherApproval(index) {
      if (this.otherInfo) {
        this.departmentId = this.otherInfo.userId
      } else {
        this.departmentId = 0
      }
      this.detailsSetOtherActiveIndex = index
      this.setOtherApprovalDialogVisible = true
      this.$nextTick(() => {
        this.$bus.emit('hignSelect', this.departmentId)
      })
    },

    /* 新增部门负责人 */
    addDeptApproval(index) {
      let obj = {
        roleType: 1,
        roleName: "部门负责人",
        isContinue: 0,
        isAddDeptApproval: 0,
        isDelDeptApproval: 1,
        isDeptApprovalNeedContinue: 0,
        userRadio: "",
        userName: "",
        userNameList: [],
      }
      let detailsList = this.procedureList[this.activeIndex].agentDepartmentList
      let nums = 0
      detailsList.map(i => {
        if (i.roleType == 1) nums++
      })
      if (nums > 1) {
        detailsList[0].isAddDeptApproval = 0
      }
      detailsList.splice(index+nums,0,obj)
    },

    delDeptApproval(index) {
      let detailsList = this.procedureList[this.activeIndex].agentDepartmentList
      detailsList.splice(index,1)
      let nums = 0
      detailsList.map(i => {
        if (i.roleType == 1) nums++
      })
      if (nums > 2) {
        detailsList[0].isAddDeptApproval = 0
      } else {
        detailsList[0].isAddDeptApproval = 1
      }
    },

    /* 跳过 */
    skip(index) {
      this.detailsList[index].isContinue = 1;
    },

    /* 恢复 */
    recovery(index) {
      this.detailsList[index].isContinue = 0;
    },

    save() {
      if (this.agentId.length == 0) {
        this.$message.error("请先选择经办人");
        return;
      }
      let isHasOtherApporval = false
      this.detailsList.map(i => {
        if (i.roleType == 13) {
          if (!i.isContinue && !i.userRadio) {
            isHasOtherApporval = true
          }
        }
      })
      if (isHasOtherApporval) {
        this.$message.error("请先设置其他审批人");
        return;
      }
      if (!this.procedureList[this.activeIndex].id) this.addProcedureList();
      if (this.procedureList[this.activeIndex].id) this.modProcedureList();
    },

    /* 新增流程 */
    addProcedureList() {
      let templateIdList = [];
      let approveSettingDetailVoList = [];
      templateIdList = this.agentId;
      this.detailsList.map((i, index) => {
        let obj = {};
        obj.isContinue = i.isContinue;
        obj.roleType = i.roleType;
        obj.userId = i.userRadio ? i.userRadio : 0;
        obj.sort = index + 1;
        approveSettingDetailVoList.push(obj);
      });
      let data = {
        templateIdList,
        approveSettingDetailVoList,
      };
      Salary.postSaveApproval(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "流程新增成功",
          });
          this.activeIndex = 0;
          this.initDetails();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 修改流程 */
    modProcedureList() {
      let id = this.procedureList[this.activeIndex].id;
      let templateIdList = [];
      let approveSettingDetailVoList = [];
      templateIdList = this.agentId;
      this.detailsList.map((i, index) => {
        let obj = {};
        obj.isContinue = i.isContinue;
        obj.roleType = i.roleType;
        obj.userId = i.userRadio ? i.userRadio : 0;
        obj.sort = index + 1;
        approveSettingDetailVoList.push(obj);
      });
      let data = {
        id,
        templateIdList,
        approveSettingDetailVoList,
      };
      Salary.postSaveApproval(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "流程修改成功",
          });
          this.activeIndex = 0;
          this.initDetails();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 选择角色用户 */
    changeRadio(val, index) {
      this.detailsList[index].userName = this.detailsList[
        index
      ].userNameList.find((ele) => ele.userId == val).userName;
    },

    /* 
      以下选择工薪模板方法 
    */
    setUp() {
      this.dialogVisible = true;
    },

    handleClose() {
      this.dialogVisible = false;
    },

    /* 确认选中的模板 */
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.agentId = [this.form.salaryTmpId];
          this.agent = this.salaryTmpList.find(
            (ele) => ele.id == this.form.salaryTmpId
          ).name;
          this.initEveryRoleTypeList(true)
          this.handleClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 关闭其他审批人弹框 */
    setOtherApprovaClose() {
      this.setOtherApprovalDialogVisible = false;
      this.$bus.emit('clearSelect', 0)
    },
    
    /* 确定选中的部门成员信息 */
    setOtherApprovaConfirm() {
      if (!this.otherInfo) {
        this.$message({
          type: "error",
          message: "请先选择成员",
        });
        return
      }
      this.detailsList[this.detailsSetOtherActiveIndex].userName = this.otherInfo.name
      this.detailsList[this.detailsSetOtherActiveIndex].userRadio = this.otherInfo.userId
      this.setOtherApprovaClose()
    },

    /* 获取选中的部门成员信息 */
    selectDepartmentList(v) {
      let obj = {}
      obj.name = v.departmentName
      obj.userId = v.id2
      this.otherInfo = obj
    },
  },
};
</script>

<style lang='scss'>
.salary-approvel {
  flex: 1;
  background: $bg-white;
  .salary-approvel-container {
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .left-container {
    width: 288px;
    @include flex-column-center;
    justify-content: space-between;
    padding: 16px;
    box-sizing: border-box;
    border-right: 1px solid $bg-ShallowLightSnow;
    .add-type-content {
      flex: 1;
      width: 256px;
      position: relative;
      overflow-y: auto;
      .type {
        height: 40px;
        @include flex-between;
        padding: 0px 12px;
        cursor: pointer;
        .type-title {
          @include flex-start;
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-grey;
          img {
            width: 20px;
            height: 20px;
            margin-right: 16px;
          }
        }
      }
      .active {
        background: $bg-Tab;
        .type-title {
          color: $color-DeepReddishBlue;
        }
      }
      .nothing-add {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        img {
          width: 104px;
          height: 87px;
        }
        p {
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-LightGrey;
          margin-top: 20px;
        }
      }
    }
  }
  .right-container {
    flex: 1;
    padding: 28px 19px;
    margin-bottom: 80px;
    .sub-title {
      color: $color-Step;
      font-size: $fs-medium-s;
      border-left: 4px solid $bg-DeepReddishBlue;
      text-align: left;
      padding-left: 5px;
      margin-bottom: 22px;
    }
    .row {
      padding-left: 38px;
      margin-bottom: 25px;
      .step {
        @include flex-start;
      }
      .step-num {
        width: 40px;
        height: 40px;
        line-height: 40px;
        margin-right: 22px;
        color: $color-white;
        background: url("../../../../assets/step.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .step-node {
        width: 40px;
        height: 40px;
        line-height: 40px;
        margin-right: 22px;
      }
      .step-active {
        width: 40px;
        height: 40px;
        line-height: 40px;
        margin-right: 22px;
        color: $color-BlackGrey;
        background: url("../../../../assets/gray.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .stepActive {
        color: $color-LightGrey;
      }
      .step-main {
        flex: 1;
        height: 56px;
        @include flex-between;
        background: $bg-StepMain;
        padding: 0px 20px;
        font-size: $fs-medium-s;
        font-weight: 400;
        color: $color-Step;
        .step-main-right {
          color: $color-MainRight;
          cursor: pointer;
        }
        .operation-btn {
          display: flex;
          .step-main-right {
            margin-left: 20px;
          }
          .del {
            color: $color-Crimson;
          }
        }
      }
      .financial-audit {
        height: 55px;
        line-height: 55px;
        margin-left: 62px;
        background: $bg-white;
        padding: 0px 20px;
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-FinancialAudit;
        border: 1px solid $bg-ShallowLightSnow;
        border-top: none;
        @include flex-start;
        .financial-title {
          margin-right: 30px;
        }
        .el-radio__label {
          color: $color-FinancialAudit;
        }
      }
    }
    .add-branch {
      @include flex-start;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-Step;
      line-height: 24px;
      margin-bottom: 25px;
      .approvel-node-title {
        font-size: $fs-medium-s;
      }
      .btn-border-text-blue,
      .btn-gray {
        margin-left: 35px;
        margin-right: 20px;
      }
    }
    .foot-container {
      width: calc(100% - 545px);
      box-sizing: border-box;
      height: 64px;
      @include flex-start;
      position: fixed;
      right: 37px;
      bottom: 0;
      padding-left: 30px;
      background: $bg-white;
      box-shadow: 0px -4px 8px 0px rgba(31, 31, 31, 0.06);
    }
    .nothing {
      position: absolute;
      left: 60%;
      top: 50%;
      transform: translate(0%, -50%);
      img {
        width: 157px;
        height: 157px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
  }
  .add-type {
    width: 200px;
  }
  .el-dropdown-link {
    @include extend-click;
  }

  .assign-name {
    img {
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }
  }
  .stayDistribution {
    display: flex;
    .table-left {
      width: 370px;
      padding: 20px;
      border-right: 1px solid $bg-ShallowLightSnow;
      box-sizing: border-box;
      overflow: hidden;
      .table-left-title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        text-align: left;
        padding-left: 28px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
    }
    .table-right {
      flex: 1;
      padding: 20px;
      box-sizing: border-box;
      overflow: hidden;
      .search-table {
        margin-bottom: 20px;
      }
    }
  }
  .select-dept-approval {
    .dialog-content {
      margin: 20px;
      background: $bg-ChangeDepartmentTree;
      .department-people {
        height: 40px;
        line-height: 40px;
        padding-left: 21px;
        text-align: left;
        font-size: $fs-small-l;
        font-weight: 400;
        color: $bg-grey;
        &:hover {
          color: $color-DepartmentPeople;
          background: $bg-ChangeDepartmentHighTree;
        }
      }
      .departmentActive {
        color: $color-DepartmentPeople;
        background: $bg-ChangeDepartmentHighTree;
      }
    }
  }

  /* 设置其他审批人弹框样式 */
  .set-other-approval {
    height: 300px;
    overflow-y: auto;
    margin: 16px;
    background: $bg-ChangeDepartmentTree;
    .el-input__prefix,
    .el-input__suffix {
      top: 2px;
    }
    .table-right {
      background: $bg-ChangeDepartmentTree;
      box-sizing: border-box;
      overflow: hidden;
      .title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        margin-bottom: 14px;
        text-align: left;
        padding-left: 28px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
    }
    .tree-people {
      padding: 0px 20px;
      .el-tree {
        background: $bg-ChangeDepartmentTree;
      }
      .search {
        .el-input__inner {
          background: $bg-ChangeDepartmentTree;
        }
      }
    }
  }
}
.delete {
  color: $color-Crimson;
  font-size: $fs-small-l;
}
</style>
